import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { caseStudies } from "@/data/content";
import { Link } from "react-router-dom";

export default function CasiStudio() {
  useSeo({
    title: "Casi Studio e Risultati",
    description:
      "Casi studio di operazioni immobiliari Opera Real Estate Partners: saldo e stralcio, sviluppo, student housing. Risultati in numeri, con piena trasparenza.",
  });

  return (
    <div>
      <section className="bg-[#0D1B2A] pt-20 pb-16 border-b border-white/5 relative noise-overlay">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 relative z-10">
          <span className="label-eyebrow">Casi Studio / Risultati</span>
          <Reveal>
            <h1 className="font-display font-light text-4xl lg:text-6xl text-white mt-4 max-w-3xl leading-tight">
              I numeri, raccontati con trasparenza
            </h1>
          </Reveal>
          <p className="text-gray-400 mt-6 max-w-2xl leading-relaxed">
            Tracciamento analitico delle performance: analisi di acquisto, costi di riqualificazione,
            tempi di cantiere e ROI generato.
          </p>
        </div>
      </section>

      <section className="bg-[#F8F9FA] py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {caseStudies.map((c, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div className="bg-[#0D1B2A] border border-white/5 h-full flex flex-col">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={c.img} alt={c.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <div className="label-eyebrow">{c.type}</div>
                    <h3 className="font-display text-xl text-white mt-3">{c.title}</h3>
                    <p className="text-sm text-gray-400 mt-3 leading-relaxed flex-1">{c.objective}</p>
                    <div className="grid grid-cols-3 gap-px bg-white/5 mt-6">
                      {c.metrics.map((m) => (
                        <div key={m.k} className="bg-[#0D1B2A] p-3 text-center">
                          <div className="font-display text-lg text-[#C5A059] tabular-nums">{m.v}</div>
                          <div className="text-[0.62rem] text-gray-500 mt-1 leading-tight">{m.k}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="border border-[#C5A059]/20 bg-[#0D1B2A] p-6 mt-12">
            <p className="text-sm text-gray-400 leading-relaxed">
              <strong className="text-gray-200">Disclaimer.</strong> I risultati indicati sono
              riferiti a operazioni specifiche e non sono indicativi di rendimenti futuri. Ogni
              investimento immobiliare comporta rischi. I dati hanno finalità illustrative.
            </p>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/investitori"
              className="inline-block bg-[#C5A059] text-[#0D1B2A] hover:bg-[#D8B978] transition-colors font-medium px-8 py-4"
            >
              Richiedi l'Investment Memorandum
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
